export const UNIVERSITEIT_STUDIES = {
  'Universiteit Bachelor': [
    // Economie & Bedrijfskunde - Economie
    'Economie',
    'Economie & Bedrijfseconomie',
    'Economie en Beleid',
    'Economie & Samenleving',
    // Economie & Bedrijfskunde - Bedrijfskunde & Management
    'Bedrijfskunde',
    'Business Administration',
    'Technische Bedrijfskunde',
    'International Business Administration',
    'International Business',
    'Entrepreneurship and Business Innovation',
    'Business Engineering',
    // Economie & Bedrijfskunde - Fiscale & Financiële Wetenschappen
    'Fiscale Economie',
    'Fiscaal Recht',
    'Accountancy',
    'Actuariële Wetenschappen',
    // Economie & Bedrijfskunde - Data & Analytics
    'Econometrics and Data Science',
    'Econometrie en Operationele Research',
    'Business Analytics',
    // Onderwijs & Opvoeding - Onderwijswetenschappen & Pedagogiek
    'Pedagogische Wetenschappen',
    'Pedagogische Wetenschappen van Primair Onderwijs',
    'Onderwijswetenschappen',
    'Onderwijs en Opvoeding',
    // Onderwijs & Opvoeding - Lerarenopleidingen
    'Lerarenopleiding Open Universiteit',
    // Kunst, Cultuur & Geschiedenis - Filosofie & Theologie
    'Filosofie',
    'Theologie',
    'Theologie en Religiewetenschappen',
    'Filosofie van een Bepaald Wetenschapsgebied',
    'Religiewetenschappen',
    // Kunst, Cultuur & Geschiedenis - Kunst & Media
    'Kunstgeschiedenis',
    'Media en Cultuur',
    'Kunsten, Cultuur en Media',
    'Media, Kunst, Design en Architectuur',
    'Theaterwetenschap',
    'Film en Literatuurwetenschap',
    // Kunst, Cultuur & Geschiedenis - Geschiedenis & Cultuurwetenschappen
    'Geschiedenis',
    'Algemene Cultuurwetenschappen',
    'Cultuurwetenschappen',
    'Oudheidwetenschappen',
    'Archeologie',
    // Gezondheid & Levenswetenschappen - Geneeskunde & Zorg
    'Geneeskunde',
    'Tandheelkunde',
    'Diergeneeskunde',
    'Zorg, Gezondheid & Samenleving',
    // Gezondheid & Levenswetenschappen - Biomedische & Farmaceutische Wetenschappen
    'Biomedical Sciences',
    'Biomedische Wetenschappen',
    'Brain Science',
    'Farmaceutische Wetenschappen',
    'Bio-Farmaceutische Wetenschappen',
    'Farmacie',
    // Gezondheid & Levenswetenschappen - Gezondheidswetenschappen & Preventie
    'European Public Health',
    'Gezondheidswetenschappen',
    'Gezondheid en Leven',
    'Gezondheid en Maatschappij',
    // Gezondheid & Levenswetenschappen - Bewegingswetenschappen & Revalidatie
    'Bewegingswetenschappen',
    'Physiotherapy and Rehabilitation Sciences',
    // Gezondheid & Levenswetenschappen - Voeding & Levenswetenschappen
    'Voeding en Gezondheid',
    'Animal Sciences',
    'Molecular Life Sciences',
    'Molecular and Biophysical Life Sciences',
    'Regenerative Medicine and Technology',
    'Klinische Technologie',
    'Moleculaire Levenswetenschappen',
    // Exacte Wetenschappen & Informatica - Wiskunde & Natuurkunde
    'Wiskunde',
    'Technische Wiskunde',
    'Mathematics',
    'Natuurkunde',
    'Technische Natuurkunde',
    'Natuur- en Sterrenkunde',
    'Sterrenkunde',
    // Exacte Wetenschappen & Informatica - Chemie & Life Sciences
    'Scheikunde',
    'Chemistry',
    'Scheikundige Technologie',
    'Molecular Science and Technology',
    // Exacte Wetenschappen & Informatica - Informatica & Kunstmatige Intelligentie
    'Informatica',
    'Computer Science',
    'Technical Computer Science',
    'Business Information Technology',
    'Technische Informatica',
    'Medische Informatiekunde',
    'Business Analytics',
    'Kunstmatige Intelligentie',
    'Artificial Intelligence',
    'Cognitive Science and Artificial Intelligence',
    'Data Science and Artificial Intelligence',
    'Data Science and Society',
    // Techniek & Engineering - Werktuigbouwkunde & Elektrotechniek
    'Werktuigbouwkunde',
    'Mechanical Engineering',
    'Mechatronica',
    'Electrical Engineering',
    // Techniek & Engineering - Bouwkunde & Civiele Techniek
    'Bouwkunde',
    'Civiele Techniek',
    'Civil Engineering',
    'Technische Bestuurskunde',
    // Techniek & Engineering - Lucht- & Ruimtevaart
    'Luchtvaart- en Ruimtevaarttechniek',
    'Maritieme Techniek',
    // Techniek & Engineering - Biotechnologie & Industriële Technologie
    'Biomedische Technologie',
    'Industrial Design',
    'Industrieel Ontwerpen',
    'Industrial Design Engineering',
    'Circular Engineering',
    'Biotechnologie',
    'Food Technology',
    // Gedrag & Maatschappij - Psychologie & Cognitieve Wetenschappen
    'Psychologie',
    'Psychobiologie',
    'Cognition, Language and Communication',
    'Psychology & Technology',
    'Computational Social Science',
    // Gedrag & Maatschappij - Sociologie & Antropologie
    'Sociologie',
    'Culturele Antropologie en Ontwikkelingssociologie',
    'Internationale Ontwikkelingsstudies',
    'Vrijetijdwetenschappen',
    // Gedrag & Maatschappij - Organisatie & Personeel
    'Personeelwetenschappen',
    'Organisatie- en Managementwetenschappen',
    // Recht, Bestuur & Politiek - Recht
    'Rechtsgeleerdheid',
    'Notarieel Recht',
    'European Law School',
    'Global Law',
    'International and European Law',
    'Fiscaal Recht',
    // Recht, Bestuur & Politiek - Politicologie & Bestuurskunde
    'Politicologie',
    'Internationale Betrekkingen en Internationale Organisatie',
    'Bestuurskunde',
    'Bestuurs- en Organisatiewetenschap',
    'Law in Society',
    // Recht, Bestuur & Politiek - Criminologie & Veiligheid
    'Criminologie',
    'Security Studies',
    // Taal & Communicatie - Communicatie & Media
    'Communicatiewetenschap',
    'Communicatie- en Informatiewetenschappen',
    'International Bachelor\'s Programme in Communication and Media',
    'Media en Informatie',
    // Taal & Communicatie - Taalwetenschap & Literatuur
    'Taalwetenschap',
    'Literatuurwetenschap',
    'Literatuur en Samenleving',
    // Taal & Communicatie - Specifieke Talen & Culturen
    'English Language and Culture',
    'Franse Taal en Cultuur',
    'Duitse Taal en Cultuur',
    'Spaanse Taal en Cultuur',
    'Italiaanse Taal en Cultuur',
    'Japanstudies',
    'Koreastudies',
    'Scandinavische Talen en Culturen',
    'Nederlandse Taal en Cultuur',
    'Midden-Oostenstudies',
    'Arabische Taal en Cultuur',
    'Griekse en Latijnse Taal en Cultuur',
    'Romaanse Talen en Culturen',
    'Chinastudies',
    'Russische Studies',
    // Aarde & Milieu - Aardwetenschappen & Duurzaamheid
    'Technische Aardwetenschappen',
    'Aarde, Economie en Duurzaamheid',
    'Future Planet Studies',
    'Soil, Water, Atmosphere',
    'Milieu-natuurwetenschappen',
    'Environmental Sciences',
    // Aarde & Milieu - Geografie, Planologie & Beheer
    'Geografie, Planologie en Milieu',
    'Human Geography and Planning',
    'Spatial Planning and Design',
    'International Land and Water Management',
    'Bos- en Natuurbeheer',
    // Aarde & Milieu - Biologie & Plantenwetenschappen
    'Biologie',
    'Plantenwetenschappen',
    'Marine Sciences',
    // Interdisciplinaire & Speciale Studies - Liberal Arts & Multidisciplinaire Studies
    'Liberal Arts and Sciences',
    'Beta-gamma',
    'Global Studies',
    'Urban Studies',
    'Science for Sustainable Societies',
    // Interdisciplinaire & Speciale Studies - Geïntegreerde Maatschappelijke Studies
    'Philosophy, Politics and Economics',
    'Global Responsibility and Leadership',
    'Technology and Liberal Arts & Sciences',
    // Interdisciplinaire & Speciale Studies - Technologische Innovatie & Creativiteit
    'Creative Technology',
    'Advanced Technology',
    // Krijgswetenschappen & Defensie - Militaire Wetenschappen & Technologie
    'Militaire Systemen & Technologie',
    'Militaire Bedrijfswetenschappen',
    // Krijgswetenschappen & Defensie - Veiligheid & Internationale Studies
    'Cybersecurity & Cybercrime',
    'International Studies',
    'Politics, Psychology, Law and Economics'
  ],
  'Universiteit Master': [
    // Management & Bedrijfskunde - Algemeen Management & Bedrijfskunde
    'Business Administration',
    'International MSc in Business Administration',
    'Executive MBA',
    'Executive MBA: Leading with Purpose',
    'International Full Time Master of Business Administration',
    'Global Executive MBA',
    'Master of Arts in Management',
    'Executive Master in Business Administration',
    'Management',
    'Bedrijfskunde',
    'International Management',
    // Management & Bedrijfskunde - Financieel Management & Accounting
    'Finance',
    'International Finance',
    'Financial Economics',
    'Finance & Investments',
    'International Financial Management',
    'Actuarial Science and Mathematical Finance',
    'Quantitative Finance and Actuarial Science',
    'Actuarial Sciences and Mathematical Finance',
    'Accounting, Auditing and Control',
    'Accountancy',
    'Executive Master of Finance and Control',
    'Executive Master in Finance',
    'Executive Master of Business Valuation',
    'Law & Finance',
    'Economics and Business',
    'Executive Master of Science in Insurance & Risk',
    'Controlling',
    'Executive Master in Finance and Control',
    'Executive Master of Actuarial Science',
    'International Executive Master of Finance and Control',
    // Management & Bedrijfskunde - Marketing & Strategie
    'Marketing',
    'Marketing Management',
    'Marketing Analytics',
    'Corporate Communication',
    'Strategic Management',
    'Strategic Entrepreneurship',
    'Executive Master of Marketing and Customer Management',
    // Management & Bedrijfskunde - Supply Chain, Operations & Logistiek
    'Supply Chain Management',
    'Global Supply Chain Management and Change',
    'Transport and Supply Chain Management',
    'Customs and Supply Chain Compliance',
    'Operations Management and Logistics',
    'Maritime Economics and Logistics',
    'Transport, Infrastructure and Logistics',
    'Spatial, Transport and Environmental Economics',
    // Management & Bedrijfskunde - Innovatie & Digital Business
    'Digital Business and Innovation',
    'Digital Business and Economics',
    'Management of Innovation',
    'Innovation Management',
    'Business Information Management',
    'Business Intelligence and Smart Services',
    'Executive Master Information Management and Digital Transformations',
    'Information Management',
    // Management & Bedrijfskunde - Ondernemerschap & Verandermanagement
    'Management, Policy Analysis and Entrepreneurship in the Health and Life Sciences',
    'Entrepreneurship',
    'Sustainable Entrepreneurship',
    'Verandermanagement',
    'People, Organisations & Change',
    // Management & Bedrijfskunde - Economie & Publieke Sector
    'Economics',
    'International Economics and Business',
    'Economics of Public Policy and Management',
    'Economics of Competition and Regulation',
    'Economics and Business',
    'Economie van de Publieke Sector',
    'International Economics and Sustainable Development',
    // Management & Bedrijfskunde - Econometrie, Wiskunde & Data Science
    'Econometrics and Operations Research',
    'Econometrics, Operations Research and Actuarial Studies',
    'Econometrics and Mathematical Economics',
    'Econometrics and Management Science',
    'Data Science and Business Analytics',
    'Research Master Business Data Science',
    // Management & Bedrijfskunde - Vastgoed & Risicomanagement
    'Master of Real Estate',
    'Real Estate Studies',
    'Master of Science in Real Estate',
    'Executive Master of Accountancy',
    'Risicomanagement',
    // Management & Bedrijfskunde - HR & Organisatie
    'Human Resource Management',
    'Human Resource Studies',
    // Management & Bedrijfskunde - Executive & Research Masters
    'Research Master in Economics and Business (research)',
    'Research Master in Economics (Research)',
    'Tinbergen Institute Research Master in Economics',
    'Economic and Financial Research (research)',
    'Multidisciplinary Economics (research)',
    // Onderwijs & Opvoeding - Algemene Onderwijswetenschappen & Pedagogiek
    'Onderwijswetenschappen',
    'Pedagogische Wetenschappen',
    'Pedagogische en Onderwijswetenschappen',
    'Education and Child Studies',
    'Educational Sciences: Learning in Interaction (research)',
    'Child Development and Education (research master)',
    'Educational Science and Technology',
    // Onderwijs & Opvoeding - Primair Onderwijs
    'Educatieve Master Primair Onderwijs',
    'Curriculumontwikkeling voor Primair Onderwijs',
    // Onderwijs & Opvoeding - Voortgezet Onderwijs (Docentenopleidingen)
    'Educatie in de Taal en Cultuurwetenschappen',
    'Educatie in de Mens en Maatschappijwetenschappen',
    'Educatie in de Bètawetenschappen',
    'Educatie en Communicatie in de Bètawetenschappen',
    'Leraar Voorbereidend Hoger Onderwijs in de Bètawetenschappen',
    'Leraar Voorbereidend Hoger Onderwijs in de Mens en Maatschappijwetenschappen',
    'Leraar Voorbereidend Hoger Onderwijs in de Taal en Cultuurwetenschappen',
    'Leraar Godsdienst en Levensbeschouwing (eerste graad)',
    // Onderwijs & Opvoeding - Specialistische Onderwijsprogramma's & Innovatie
    'Learning and Development in Organisations',
    'Gifted Education and Care',
    'Science Education and Communication',
    'Executieve MSc Senior Docent Ontwerpen',
    // Kunst & Cultuur - Geschiedenis & Archeologie
    'Geschiedenis',
    'Archeologie',
    'Historical, Literary and Cultural Studies',
    'History and Philosophy of Science',
    // Kunst & Cultuur - Filosofie & Logica
    'Filosofie',
    'Logic',
    'Philosophy of Science, Technology and Society',
    'Filosofie van Cultuur en Bestuur',
    // Kunst & Cultuur - Kunst, Cultuur & Erfgoed
    'Kunst & Cultuurwetenschappen',
    'Mediastudies',
    'Arts, Literature and Media',
    'Erfgoedstudies',
    'Conservering en Restauratie van Cultureel Erfgoed',
    'Executive Master in Cultural Leadership',
    // Kunst & Cultuur - Theologie & Religie
    'Theologie',
    'Theologie & Religiewetenschappen',
    'Religious Studies',
    'Herbronning Gereformeerde Theologie',
    'Geestelijke Verzorging',
    'Humanistiek',
    // Kunst & Cultuur - Zorgethiek & Beleid
    'Zorgethiek en Beleid',
    // Kunst & Cultuur - Algemene Geesteswetenschappen
    'Humanities',
    // Gezondheid - Geneeskunde & Klinisch Onderzoek
    'Geneeskunde',
    'Geneeskunde en Klinisch Onderzoek',
    'Geneeskunde, Klinisch Onderzoeker',
    'Medicine',
    'Technical Medicine',
    'Oncology',
    'Oral Health Sciences',
    'Tandheelkunde',
    'Diergeneeskunde',
    // Gezondheid - Biomedische Wetenschappen & Farmacie
    'Biomedical Sciences',
    'Biomedical Technology and Physics',
    'Bio-Pharmaceutical Sciences',
    'Medical Pharmaceutical Sciences',
    'Molecular Medicine',
    'Molecular Medicine and Innovative Treatment',
    'Molecular Sciences',
    'Molecular Life Sciences',
    'Drug Discovery Sciences',
    'Infection and Immunity',
    'Transfusion Medicine and Cellular and Tissue Therapies',
    // Gezondheid - Gezondheidswetenschappen & Volksgezondheid
    'Health Sciences',
    'Master in Health Sciences',
    'Global Health',
    'European Master in Health Economics and Management',
    'Governance and Leadership in European Public Health',
    'Population Health Management',
    'Clinical and Psychosocial Epidemiology',
    'Epidemiology',
    'Public Health (onderliggend aan meerdere opleidingen)',
    // Gezondheid - Gezondheidseconomie, Beleid & Management
    'Health Economics, Policy and Law',
    'Healthcare Policy, Innovation and Management',
    'Zorgmanagement',
    'Executive Master of Health Administration',
    'Health and Digital Transformation',
    // Gezondheid - Voeding, Innovatie & Veiligheid
    'Nutrition and Health',
    'Health Food Innovation Management',
    'Food Safety',
    'Food Quality Management',
    // Gezondheid - Bewegingswetenschappen & Sport
    'Human Movement Sciences',
    'Bewegingswetenschappen',
    'Human Movement Sciences: Sport, Exercise and Health',
    'Sport Sciences',
    'Musculoskeletal Physiotherapy Sciences',
    // Gezondheid - Medische Informatica & Technologie
    'Medical Informatics',
    'Health Informatics',
    // Gezondheid - Arbeidsgezondheid & Duurzaamheid
    'Occupational Health and Sustainable Work',
    'European MSc in Occupational Therapy',
    // Gezondheid - Onderwijs & Ethiek binnen de Gezondheidszorg
    'Health Professions Education',
    'Evidence-Based Practice in Health Care',
    'Medical Humanities',
    // Gezondheid - Kwaliteit, Veiligheid & Innovatie in de Zorg
    'Kwaliteit en Veiligheid in de Patiëntenzorg',
    'Health Education and Promotion',
    // Gezondheid - Dierwetenschappen & Aquatische Wetenschappen
    'Animal Sciences',
    'Aquaculture and Marine Resource Management',
    // Exact & Informatie - Informatica & Softwareontwikkeling
    'Computer Science',
    'Computer Science and Engineering',
    'Software Engineering',
    'Business Information Technology',
    'ICT in Business and the Public Sector',
    'Business Process Management and IT',
    'Executive Master of IT-Auditing',
    // Exact & Informatie - Kunstmatige Intelligentie & Data Science
    'Artificial Intelligence',
    'Data Science and Artificial Intelligence Technology',
    'Applied Data Science',
    'Data Science and Society',
    'Data Science for Decision Making',
    'Business Analytics',
    'Computational Science',
    'Computational Cognitive Science',
    'Stochastics and Financial Mathematics',
    // Exact & Informatie - Cybersecurity & Netwerken
    'Security and Network Engineering',
    'Computer Security',
    'Forensic Science',
    // Exact & Informatie - Robotica & Mens-Technologie Interactie
    'Robotics',
    'Human-Technology Interaction',
    'Interaction Technology',
    'Creative Intelligence & Technology',
    // Exact & Informatie - Wiskunde & Statistiek
    'Mathematics',
    'Applied Mathematics',
    'Mathematische Wetenschappen',
    'Statics and Data Science',
    // Exact & Informatie - Natuurkunde & Sterrenkunde
    'Physics',
    'Applied Physics',
    'Physics and Astronomy',
    'Astronomy',
    'Quantum Information Science & Technology',
    'Quantum Computer Science',
    'Science and Technology of Nuclear Fusion',
    // Exact & Informatie - Chemie & Materiaalkunde
    'Chemistry',
    'Chemical Science & Engineering',
    'Chemical Engineering',
    'Chemische Wetenschappen',
    // Exact & Informatie - Innovatie & Wetenschapsmanagement
    'Innovation Sciences',
    'Science and Innovation',
    'Science, Business and Innovation',
    'Natuurwetenschappen en Bedrijf',
    'Technology and Operations Management',
    // Techniek - Biotechnologie & Levenswetenschappen
    'Biotechnology',
    'Life Science and Technology',
    'Biomolecular Sciences',
    'Bioinformatics',
    'Biomedical Engineering',
    'Biosystems Engineering',
    'Medical Engineering',
    // Techniek - Duurzaamheid & Energie
    'Sustainable Energy Technology',
    'European Master in Renewable Energy',
    'Environmental and Energy Management',
    'Environmental Engineering',
    'Water Technology',
    // Techniek - Elektrotechniek & Embedded Systems
    'Electrical Engineering',
    'Embedded Systems',
    // Techniek - Werktuigbouwkunde & Mechatronica
    'Mechanical Engineering',
    'Automotive Technology',
    'Systems and Control',
    // Techniek - Bouwkunde, Stedenbouw & Civiele Techniek
    'Civil Engineering',
    'Civil Engineering and Management',
    'Architecture, Urbanism and Building Sciences',
    'Architecture, Building and Planning',
    'Construction Management and Engineering',
    'Urban Management and Development (M.Sc.)',
    'Master City Developer',
    'The Berlage post-master in Architecture and Urban Design',
    // Techniek - Maritieme & Offshore Techniek
    'Marine Technology',
    'Offshore and Dredging Engineering',
    // Techniek - Ruimtevaart & Nanotechnologie
    'Aerospace Engineering',
    'Nanotechnology',
    'Nanoscience',
    // Techniek - Industrieel Ontwerpen & Productontwikkeling
    'Industrial Design Engineering',
    'Industrial Design',
    'Integrated Product Design',
    'Design for Interaction',
    'Strategic Product Design',
    // Techniek - Technologiemanagement & Beleidsanalyse
    'Complex Systems Engineering and Management',
    'Engineering and Policy Analysis',
    'Management of Technology',
    // Techniek - Materialen & Productietechnologie
    'Materials Science and Engineering',
    // Techniek - Data Science & Ondernemerschap
    'Data Science in Business and Entrepreneurship',
    // Techniek - Humanitaire & Sociale Techniek
    'Humanitarian Engineering',
    // Gedrag & Maatschappij - Psychologie & Neurowetenschappen
    'Psychologie',
    'Psychologie en Geestelijke Gezondheid',
    'Gezondheidszorgpsychologie',
    'Medische Psychologie',
    'Cognitive Neuropsychology',
    'Social & Health Psychology',
    'Social Psychology',
    'Social Psychology: Regulation of Social Behaviour',
    'Forensic Psychology',
    'Individual Differences and Assessment',
    'Cognitive and Clinical Neuroscience',
    'Neuroscience',
    'Neuroscience and Cognition',
    'Behavioural and Cognitive Neurosciences',
    'Genes in Behaviour and Health',
    'Human Decision Science',
    // Gedrag & Maatschappij - Sociologie & Sociale Wetenschappen
    'Sociologie',
    'Sociology and Social Research',
    'Social and Behavioural Sciences',
    'Behavioural and Social Sciences',
    'Behavioural Science',
    'Interdisciplinaire Sociale Wetenschap',
    'Social and Cultural Science: Comparative Research on Societies',
    'Societal Transitions',
    'Social Sciences',
    'Social Sciences for a Digital Society',
    'Culture, Organization and Management',
    'Burgerschap en Kwaliteit van Samenleven',
    // Gedrag & Maatschappij - Antropologie & Culturele Studies
    'Cultural Anthropology: Sociocultural Transformation',
    'Culturele Antropologie',
    'Culturele Antropologie en Sociologie der Niet-Westerse Samenlevingen',
    'Social and Cultural Anthropology',
    'Cultural Anthropology and Development Sociology',
    'Medische Antropologie en Sociologie',
    // Gedrag & Maatschappij - Internationale Ontwikkeling & Globalisering
    'International Development Studies',
    'International Development',
    'Development Studies',
    'Globalisation and Development Studies',
    'Development and Rural Innovation',
    'Anthropology and Development Studies',
    // Gedrag & Maatschappij - Migratie & Multiculturele Samenlevingen
    'Migration, Ethnic Relations and Multiculturalism',
    // Gedrag & Maatschappij - Toegepaste Sociale Wetenschappen & Organisatiepsychologie
    'International Joint Master of Research in Work and Organizational Psychology',
    // Gedrag & Maatschappij - Vrije Tijd, Toerisme & Samenleving
    'Leisure and Tourism Studies',
    'Tourism, Society and Environment',
    // Gedrag & Maatschappij - Onderzoeksmethoden & Statistiek
    'Methodology and Statistics for the Behavioural, Biomedical and Social Sciences',
    // Recht & Bestuur - Algemeen Recht & Rechtsgeleerdheid
    'Nederlands recht',
    'Rechtsgeleerdheid',
    'Privaatrecht',
    'Publiekrecht',
    'Rechtwetenschappelijk Onderzoek',
    // Recht & Bestuur - Internationaal & Europees Recht
    'International Laws',
    'International and European Law',
    'International Business Law',
    'International Commercial Law',
    'Globalisation and Law',
    'European Private Law',
    'European Law in a Global Context',
    'Public International Law',
    'International Tax Law',
    'International and European Tax Law',
    'Advanced Studies in International Civil and Commercial Law',
    'Advanced Studies in Public International Law',
    'Advanced Studies in European and International Business Law',
    'Advanced Studies in European and International Human Rights Law',
    // Recht & Bestuur - Ondernemingsrecht & Financieel Recht
    'Ondernemingsrecht',
    'Onderneming en recht',
    'Commercial Law',
    'Advanced Studies in Law and Finance',
    'Law and Economics',
    // Recht & Bestuur - Arbeidsrecht & Sociaal Recht
    'Arbeidsrecht',
    'Recht en Arbeid',
    'Sociaal Recht en Sociale Politiek',
    // Recht & Bestuur - Fiscaal & Notarieel Recht
    'Fiscaal Recht',
    'Notarieel Recht',
    // Recht & Bestuur - Technologie, Privacy & Intellectueel Eigendom
    'Law and Technology',
    'IT-recht',
    'Advanced Master Intellectual Property Law and Knowledge Management LL.M.',
    'Advanced Studies in Law and Digital Technologies',
    'Gegevensbescherming en Privacyrecht',
    // Recht & Bestuur - Klimaat-, Energie- & Ruimterecht
    'Energy and Climate Law',
    'Advanced Master in Energy Law',
    'Advanced Studies in Air and Space Law',
    // Recht & Bestuur - Strafrecht, Criminologie & Veiligheid
    'Criminologie',
    'Forensische Criminologie',
    'Global Criminal Law',
    'International Criminal Law',
    'International Crimes, Conflict and Criminology',
    'Criminaliteit en Rechtshandhaving',
    'Forensica, Criminologie en Rechtspleging',
    'Law and Politics of International Security',
    // Recht & Bestuur - Bestuurskunde & Openbaar Bestuur
    'Bestuurskunde',
    'Public Administration',
    'Recht en Bestuur',
    'Publiek Management',
    'Management Publieke Sector',
    'Executive Master of Public and Non-profit Management',
    'Research in Public Administration and Organizational Science',
    // Recht & Bestuur - Beleid & Organisatie
    'Public Policy and Human Development',
    'Erasmus Mundus Master\'s Program in Public Policy',
    'International Public Management and Public Policy',
    'Conflict Resolution and Governance',
    'Beleid, Communicatie en Organisatie',
    'Sustainability Science, Policy and Society',
    'Governance of Sustainability',
    'Organization and Management Studies',
    // Recht & Bestuur - Internationale Betrekkingen & Diplomatie
    'Internationale betrekkingen',
    'International Relations and Diplomacy',
    // Recht & Bestuur - Specialisaties in Recht
    'Advanced Studies in International Children\'s Rights',
    'Advanced Studies in International Dispute Settlement and Arbitration',
    'Advanced LLM in Technology Governance',
    'Mater of Science in Policing',
    'Togamaster',
    'Jeugdrecht',
    'Aansprakelijkheid en verzekering',
    // Recht & Bestuur - Management & Leiderschap binnen Recht en Bestuur
    'Executive Master of Management and Organization',
    'Executive Master of Management in Education'
  ]
}
